/* eslint-disable */
export default {
    // Campos no complejos (no son JSONs ni arrays) que pueden buscarse por coincidencia exacta
    notComplexFields: {
        users: [
            'created_on',
            'deleted_on',
            'department',
            'updated_on',
            'username'
        ],
        accounts: [
            'account_type',
            'account_issues_count',
            'alias_account',
            'created_on',
            'distributor',
            'first_subscription_date',
            'has_docs_been_downloaded',
            'has_docs_signed',
            'has_docs_validated',
            'signature_type',
            'status',
            'subdistributor',
            'updated_on',
            'withholding_group',
            'saldo_participaciones',
            'valoracion_inversion',
            'has_changed_distributor'
        ],
        groups: [
            'description',
            'key_name',
            'total_users',
            'uuid'
        ],
        permission_sets: [
            'description',
            'display_name',
            'key_name',
            'uuid'
        ],
        interveners: [
            'birthdate',
            'class',
            'created_on',
            'deathdate',
            'deleted_on',
            'disability_grade',
            'distributor',
            'document_type',
            'f_address_street_1',
            'f_address_postal_code',
            'f_address_state',
            'f_address_city',
            'gender',
            'has_active_position',
            'has_docs_validated',
            'intervener_status',
            'intervener_type',
            'key_nationality_1',
            'key_nationality_2',
            'marital_status',
            'mobile_phone',
            'subdistributor',
            'updated_on',
            'videoidentification_status',
            'has_done_private_area_first_login'
        ],
        issues: [
            'blocking',
            'category',
            'created_on',
            'document_subcategory',
            'expires_on',
            'group_assigned',
            'object_type',
            'resolved_on',
            'status',
            'subject',
        ],
        operations: [
            'account_id_object',
            'alias_account',
            'amount_shares_indicator',
            'created_on',
            'currency',
            'expires_on',
            'fiscal_amount',
            'gross_amount',
            'key_operation_type',
            'key_sub_operation_type',
            'key_product',
            'name_product',
            'name_target_product',
            'nav_date',
            'operation_date',
            'operation_issues_count',
            'operation_status',
            'parent_product_name',
            'pay_method',
            'per_end_date',
            'per_increase',
            'per_increase_period',
            'per_increase_type',
            'per_start_date',
            'ind_percepcion_pres',
            'ind_tipo_pres',
            // COMENTADOS los campos de conciliación: YURI-2386
            'request_date',
            'updated_on',
            'xt_acount_origin',
            'xt_fund_name',
            'xt_fund_nif',
            'xt_fund_official_reg_number',
            'xt_gestor',
            'xt_gestor_nif',
            'xt_gestor_official_reg_number',
            'xt_isin_code',
            'xt_provider',
            'xt_provider_nif',
            'xt_provider_official_reg_number'
        ]
    },
    // Campos que son strings(o pueden convertirse a string) y que pueden buscarse por coincidencia
    contentSearchableFields: {
        users: [
            'department',
            'family_name_1',
            'family_name_2',
            'given_name',
            'username'
        ],
        accounts: [
            'account_issues_count',
            'alias_account',
            'id_object',
            'interveners'
        ],
        groups: [
            'description',
            'key_name'
        ],
        permission_sets: [
            'description',
            'display_name',
            'key_name'
        ],
        interveners: [
            'city_of_birth',
            'id_object',
            'lastname_1',
            'lastname_2',
            'name',
            'document_id',
            'email',
            'home_phone',
            'intervener_issues_count',
            'mobile_phone',
            'f_address_street_1',
            'f_address_postal_code',
            'f_address_city',
            'f_address_state'
        ],
        issues: [
            'category',
            'description',
            'document_subcategory',
            'group_assigned',
            'subject',
            'user_assigned',
            'user_opened'
        ],
        operations: [
            'account_id',
            'account_id_object',
            'alias_account',
            'id_object',
            'interveners',
            'operation_id',
            'user_owner',
            'xt_acount_origin',
            'xt_fund_name',
            'xt_fund_nif',
            'xt_fund_official_reg_number',
            'xt_gestor',
            'xt_gestor_nif',
            'xt_gestor_official_reg_number',
            'xt_isin_code',
            'xt_provider',
            'xt_provider_nif',
            'xt_provider_official_reg_number'
        ]
    },
    // Campos que pueden ser comparados por rangos numéricos (mayor/menor)
    numericComparisionFields: {
        users: [
            'created_on',
            'deleted_on',
            'updated_on'
        ],
        accounts: [
            'account_issues_count',
            'created_on',
            'updated_on',
            'saldo_participaciones',
            'valoracion_inversion'
        ],
        groups: [
            'total_users'
        ],
        permission_sets: [
        ],
        operations: [
            'created_on',
            'expires_on',
            'fiscal_amount',
            'gross_amount',
            'net_amount',
            'request_date',
            'nav',
            'nav_date',
            'operation_date',
            'updated_on',
            'operation_issues_count',
            'per_end_date',
            'per_start_date',
            'shares',
            'transfer_nav_on_month_end',
            'withholding',
            'commission',
            'per_increase',
            'xt_rejection_date'
        ],
        interveners: [
            'birthdate',
            'created_on',
            'deathdate',
            'updated_on',
            'intervener_issues_count'
        ],
        issues: [
            'created_on',
            'expires_on',
            'resolved_on'
        ],
        permission_set: []
    },
    conditions: {
        nullConditions: [
            { value: 'null', text: 'Es nulo' },
            { value: '!null', text: 'No es nulo' }
        ],
        equalityComparisonConditions: [
            { value: 'eq', text: 'Igual a' },
            { value: 'ne', text: 'No igual a' }
        ],
        numericComparisionConditions: [
            { value: 'gt', text: 'Mayor que' },
            { value: 'gte', text: 'Mayor o igual que' },
            { value: 'lt', text: 'Menor que' },
            { value: 'lte', text: 'Menor o igual que' }
        ],
        contentConditions: [
            { value: 'in', text: 'Contiene' },
            { value: 'nin', text: 'No contiene' }
        ],
        startsConditions: [
            { value: 'in_starts', text: 'Empieza por' }
        ]
    }
};
